/*
Ravi 04/03/2023 2699762545 Added download icon in action
Ravi 04/05/2023 2699762545 changed download tooltip download Batch to download Letter
Guru Prasad 04/04/2023 2699762545 Fixed table alignment
Gireesh 06/04/2023 2699762545 Added Letter Info Column
Sohel 04/06/2023 2699762545 Implement View Functionality
Ravi 04/07/2023 2699762545 show Batch Name
Prakash 30/06/2023 2699762545 fixed table alignments issue
Prakash 16/06/2023 2699762545 fixed icon issues in Client Maintenance

*/
import React, {createRef, useState, useEffect} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../components/TableIcons/index';
import {makeStyles, Button} from '@material-ui/core';
import {Link} from 'react-router-dom';
import {useLocation} from 'react-router';
import {useDispatch, useSelector} from 'react-redux';
import {tablePageRows, defaultRows} from '../../../../constants/ReusableTablePagination';
import {
  downloadLetterFileByUrl,
  fetchLettersData,
  getTemplateDocumentLink,
  resetTemplateLinkData,
} from '../../../../redux/reducers/LetterBatches';
import {fetchAccountSummary} from '../../../../redux/reducers/AccountSummary';
import moment from 'moment';
import GetAppIcon from '@material-ui/icons/GetApp';
import FileViewer from 'react-file-viewer';
import {
  resetLetters,
  resetApproveBatch,
} from '../../../../redux/reducers/LetterBatches';
import {SuccessSnackbar} from '../../../../components/CustomSnackBar';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {ArrowBack} from '@material-ui/icons';
import {backToBatches} from './../../../../util/Content';
import ScanFormDialog from '../../../LetterMaintenance/MaintainLetters/GeneralInformation/ScanFormDialog';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

const useStyles = makeStyles((theme) => ({
  cardStyles: {
    whiteSpace: 'nowrap',
    padding: 10,
    marginTop: 20,
    marginBottom: 10,
    boxShadow:
      '0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
  },

  toolTip: {
    zIndex: '9 !important',
  },

  batchNumber: {
    color: '#320469',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  disabledBatchNumber: {
    color: '#676767',
    textDecoration: 'underline',
  },
}));
const ViewCandidates = ({label, setLabel, setPaymentData, batchName, batchId, setValue, batchView}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const location = useLocation();
  const tableRef = createRef();
  const {lettersData, templateLink} = useSelector(({letterBatches}) => letterBatches);
  const [openTemplate, setOpenTemplate] = useState(false);
  const getApiData =
    lettersData && lettersData.length > 0 ?
      lettersData.map((item, i) => ({
        ...item,
        id: i,
      })) :
      [];

  useEffect(() => {
    dispatch(resetLetters());
  }, []);

  const handleClose = () => {
    setOpenTemplate(false);
    dispatch(resetTemplateLinkData());
  };
  const handleViewLetter = (key) => {
    setOpenTemplate(true);
    if (key) {
      dispatch(getTemplateDocumentLink({dockey: key}));
    }
  };

  useEffect(() => {
    (batchName || location?.state?.batchName) &&
      dispatch(fetchLettersData(batchName || location?.state?.batchName));
  }, [batchName, location?.state?.batchName]);
  const {successMsg, isLoading} = useSelector(
    ({letterBatches}) => letterBatches,
  );

  useEffect(() => {
    if (successMsg) {
      setTimeout(() => {
        dispatch(resetApproveBatch());
      }, 3000);
    }
  }, [successMsg]);
  const columns = [
    {
      title: 'Account Number',
      field: 'accountNumber',
      maxWidth: 150,
      render: (rowData) => {
        return batchView && rowData && rowData.accountNumber ? (
          <Link
            onClick={() =>
              // sessionStorage.setItem("batchName", batchName ? batchName : batch ? batch : null)
              dispatch(fetchAccountSummary(rowData?.accountNumber ? rowData.accountNumber : ''))
            }
            to={{
              pathname: `/account-summary`,
              state: {
                accountNumber: rowData?.accountNumber ? rowData.accountNumber : '',
                // batchName: batchName ? batchName : batch ? batch : null,
                // accountData: accountData?.length > 0 ? accountData : [],
              },
            }}
            className={`pointer ${classes.batchNumber}`}
          >
            {rowData.accountNumber}
          </Link>
        ) : <div>{rowData.accountNumber}</div>;
      },
    },
    {
      title: 'Code',
      field: 'letterCode',
      maxWidth: 130,
    },
    {
      title: 'Description',
      field: 'letterDescription',
      maxWidth: 130,
    },
    {
      title: 'Type',
      field: 'letterType',
      maxWidth: 140,
    },
    {
      title: 'Batch Date',
      field: 'batchDate',
      maxWidth: 170,
      render: (rowData) =>
        rowData.batchDate ? moment(rowData.batchDate).format('MM/DD/YYYY') : '',
    },
    // {
    //   title: "Email",
    //   field: "emailAddress",
    //   maxWidth: 180,
    // },
    {
      title: 'Requested Date',
      field: 'requestedDate',
      maxWidth: 165,
      // customFilterAndSearch: (term, rowData) => {
      //   return moment(rowData.requestedDate).format("MM/DD/YYYY").toString().indexOf(term) > -1;
      // },
      render: (rowData) =>
        rowData.requestedDate ? moment(rowData.requestedDate).format('MM/DD/YYYY') : '',
    },
    {
      title: 'Requested By',
      field: 'requestedBy',
      maxWidth: 130,
    },
    {
      title: 'Information',
      field: 'letterData',
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 400,
              minWidth: 400,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordBreak: ' break-all',
            }}
          >
            {rowData?.letterData}
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <ScanFormDialog title="Document" open={openTemplate} fullBox dialogClose={handleClose}>
        {templateLink && <FileViewer fileType="docx" filePath={templateLink} />}
        {/** onError={onError} */}
      </ScanFormDialog>
      {batchView && <div className="button-table-spacing-mb justify-content-start new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn`}
          onClick={() => {
            setValue(0);
          }}
        >
          <ArrowBack className="mr-2" />
          {backToBatches}
        </Button>
      </div>}
      <div
        className={ batchView ? `custom-table custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields` 
          : `custom-table global-field-table custom-actions-icon custom-toolbar-icons trigger-table new-standard-textfields px-3`}
      >
        <GuiTable
          icons={tableIcons}
          title={batchView ? `Batch Name : ${batchName}` : ''}
          // title={
          //   batchName
          //     ? batchName
          //     : accountData?.length > 0 && location?.state?.batchName
          //       ? location?.state?.batchName
          //       : null
          // }

          columns={columns}
          tableRef={tableRef}
          data={getApiData}
          isLoading={isLoading}
          options={{
            search: false,
            toolbar: batchView || '',
            pageSize: defaultRows,
            pageSizeOptions: tablePageRows,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          actions={ batchView && [
            (rowData) => ({
              icon: () => <GetAppIcon />,
              tooltip: 'Download Letter',
              disabled: !rowData?.docKey,
              onClick: (event, rowData) => {
                dispatch(downloadLetterFileByUrl({dockey: rowData?.docKey}));
              },
            }),
            (rowData) => {
              return {
                icon: () => <VisibilityOutlinedIcon />,
                tooltip: 'View',
                disabled: !rowData?.docKey,
                onClick: (event, rowData) => {
                  handleViewLetter(rowData?.docKey);
                },
              };
            },
          ]}
        />
      </div>
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default ViewCandidates;
